export default {
  score: 0,
};
